import { render, staticRenderFns } from "./HorseProduct.vue?vue&type=template&id=590d0827&"
import script from "./HorseProduct.vue?vue&type=script&lang=js&"
export * from "./HorseProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports